import { makeStyles } from '@material-ui/core';
import bg from 'assets/img/premis_house.png';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.custom.bg,
    backgroundImage: `url(${bg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '30%',
    backgroundPosition: 'right bottom',
  },
}));
